import {
  FILTER_ACCOUNTS_GRID_SORTING,
  FILTER_ACCOUNTS_GRID_MANAGEMENT,
  FILTER_ACCOUNTS_GRID_ACCOUNT_TYPE,
  FILTER_ACCOUNTS_GRID_PRINT_LAYOUT,
  FILTER_ACCOUNTS_GRID_MOBILE_COLUMN,
  RESET_ACCOUNTS_GRID_FILTERS
} from 'state/account/AccountsGridFilteringActions';

export const initialAccountsGridFilteringState = {
  sorting: {
    selection: 'desc',
    options: [
      {
        label: 'Retirement → Non-Retirement',
        value: 'desc'
      },
      {
        label: 'Non-Retirement → Retirement',
        value: 'asc'
      },
      {
        label: 'Product Type',
        value: 'productType'
      },
      {
        label: 'Ownership → Registration',
        value: 'ownership'
      }
    ]
  },
  management: {
    selection: 'all',
    options: [
      {
        label: 'All',
        value: 'all'
      },
      {
        label: 'Advisory',
        value: 'advisory'
      },
      {
        label: 'Self-Managed',
        value: 'selfManaged'
      }
    ]
  },
  accountType: {
    selection: 'all',
    options: [
      {
        label: 'All',
        value: 'all'
      },
      {
        label: 'Retirement Advisory Service',
        value: 'activeAdvisory'
      },
      {
        label: 'ActivePlus Portfolios',
        value: 'activePlus'
      },
      {
        label: 'Mutual Funds',
        value: 'mutualFund'
      },
      {
        label: 'Brokerage',
        value: 'brokerage'
      },
      {
        label: '529 College Savings Plans',
        value: 'collegeSavings'
      },
      {
        label: 'Retirement',
        value: 'retirement'
      },
      {
        label: 'Non-Retirement',
        value: 'nonRetirement'
      },
      {
        label: 'Owned',
        value: 'owned'
      },
      {
        label: 'Related',
        value: 'related'
      },
      {
        label: 'View Only',
        value: 'viewOnly'
      },
      {
        label: 'Custom',
        value: 'custom'
      }
    ]
  },
  mobile: {
    selection: 'balance',
    options: [
      {
        label: 'Balance',
        value: 'balance'
      },
      {
        label: 'Quantity',
        value: 'quantitySum'
      },
      {
        label: 'Price',
        value: 'priceSum'
      },
      {
        label: 'Daily Price Change',
        value: 'dailyPriceChangeSum'
      },
      {
        label: 'Daily Change - Dollars',
        value: 'difference'
      },
      {
        label: 'Daily Change - Percent',
        value: 'priceChangePercentSum'
      },
      {
        label: 'Personal Rate of Return',
        value: 'performance'
      }
    ]
  }
};

export const accountsGridPrintLayoutInitialState = 'none';

export const accountsGridFiltersReducer = (
  state = initialAccountsGridFilteringState,
  action
) => {
  const { selection, type } = action;
  const { sorting, management, mobile, accountType } = state;

  if (type === FILTER_ACCOUNTS_GRID_SORTING) {
    return {
      ...state,
      sorting: {
        ...sorting,
        selection
      }
    };
  }

  if (type === FILTER_ACCOUNTS_GRID_MANAGEMENT) {
    return {
      ...state,
      management: {
        ...management,
        selection
      }
    };
  }

  if (type === FILTER_ACCOUNTS_GRID_MOBILE_COLUMN) {
    return {
      ...state,
      mobile: {
        ...mobile,
        selection
      }
    };
  }

  if (type === FILTER_ACCOUNTS_GRID_ACCOUNT_TYPE) {
    return {
      ...state,
      accountType: {
        ...accountType,
        selection
      }
    };
  }

  if (type === RESET_ACCOUNTS_GRID_FILTERS) {
    return initialAccountsGridFilteringState;
  }

  return state;
};

export const accountsGridPrintLayoutReducer = (
  state = accountsGridPrintLayoutInitialState,
  action
) => {
  const { selection, type } = action;
  if (type === FILTER_ACCOUNTS_GRID_PRINT_LAYOUT) {
    return selection ? selection : 'none';
  }
  return state;
};
